var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1978",
    "data-name": "Grupo 1978",
    transform: "translate(-170.072 -214.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10",
    "data-name": "Caminho 10",
    d: "M306.072,245.472V214.546h-136v34.3h0v34.3h136V245.472Z",
    transform: "translate(0 0)",
    fill: "#b1904e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11",
    "data-name": "Caminho 11",
    d: "M306.072,327.564V296.637h-136v34.3h0v34.3h136V327.564Z",
    transform: "translate(0 -14.684)",
    fill: "#b1904e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M304.809,246V216.547H172.073v32.664h0v32.663H304.809V246Z",
    transform: "translate(-0.369 -0.369)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    "data-name": "Caminho 13",
    d: "M304.809,328.093V298.638H172.073V331.3h0v32.664H304.809V328.093Z",
    transform: "translate(-0.369 -15.052)",
    fill: "#b1904e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(188.917 302.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14",
    "data-name": "Caminho 14",
    d: "M193.176,335.355V322.295h9.242v2.389h-6.462v2.839h6.325v2.389h-6.325v3.035h6.462v2.409Z",
    transform: "translate(-193.176 -322.099)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_15",
    "data-name": "Caminho 15",
    d: "M209.017,331.356a5.727,5.727,0,0,0,4.152,1.762c1.527,0,2.271-.724,2.271-1.468,0-.979-1.135-1.312-2.644-1.665-2.134-.489-4.875-1.077-4.875-3.994,0-2.173,1.879-3.936,4.954-3.936a7.264,7.264,0,0,1,5.091,1.821l-1.547,2.036a5.571,5.571,0,0,0-3.74-1.429c-1.253,0-1.918.548-1.918,1.331,0,.881,1.1,1.156,2.6,1.508,2.154.489,4.9,1.135,4.9,4.034,0,2.388-1.7,4.19-5.228,4.19a7.522,7.522,0,0,1-5.541-2.076Z",
    transform: "translate(-195.814 -322.055)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_16",
    "data-name": "Caminho 16",
    d: "M224.6,331.356a5.729,5.729,0,0,0,4.152,1.762c1.527,0,2.271-.724,2.271-1.468,0-.979-1.135-1.312-2.644-1.665-2.134-.489-4.875-1.077-4.875-3.994,0-2.173,1.879-3.936,4.954-3.936a7.264,7.264,0,0,1,5.091,1.821L232,325.912a5.571,5.571,0,0,0-3.74-1.429c-1.253,0-1.918.548-1.918,1.331,0,.881,1.1,1.156,2.6,1.508,2.153.489,4.895,1.135,4.895,4.034,0,2.388-1.7,4.19-5.228,4.19a7.523,7.523,0,0,1-5.542-2.076Z",
    transform: "translate(-198.561 -322.055)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17",
    "data-name": "Caminho 17",
    d: "M239.907,335.355V322.295h9.242v2.389h-6.462v2.839h6.325v2.389h-6.325v3.035h6.462v2.409Z",
    transform: "translate(-201.597 -322.099)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_18",
    "data-name": "Caminho 18",
    d: "M264.865,335.355l-6.226-8.773v8.773h-2.781V322.295h2.859l6.051,8.459v-8.459h2.781v13.061Z",
    transform: "translate(-204.464 -322.099)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_19",
    "data-name": "Caminho 19",
    d: "M277.515,335.355V324.743H273.7v-2.448h10.417v2.448h-3.8v10.613Z",
    transform: "translate(-207.682 -322.099)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20",
    "data-name": "Caminho 20",
    d: "M289.96,335.355V322.295h2.781v13.061Z",
    transform: "translate(-210.568 -322.099)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_21",
    "data-name": "Caminho 21",
    d: "M307.051,335.355l-.822-2.252h-5.835l-.823,2.252h-3.055l5.052-13.061h3.485l5.032,13.061Zm-3.74-10.652-2.173,5.992h4.327Z",
    transform: "translate(-211.777 -322.099)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5",
    transform: "translate(25.371 18.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M228.513,344.553a3.968,3.968,0,0,1,3.506,1.854l-1.5.812a2.406,2.406,0,0,0-2.007-1.066,2.784,2.784,0,0,0,0,5.562,2.866,2.866,0,0,0,1.83-.647v-1.029h-2.261V348.49h4.038v3.238a4.7,4.7,0,0,1-3.607,1.6,4.39,4.39,0,1,1,0-8.776Z",
    transform: "translate(-224.006 -344.553)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M241.754,353.195l-1.664-3.035h-1.321v3.035h-1.8v-8.471h3.962a2.638,2.638,0,0,1,2.844,2.731,2.43,2.43,0,0,1-1.854,2.515l1.9,3.225Zm-1.093-6.921h-1.892v2.336h1.892a1.172,1.172,0,1,0,0-2.336Z",
    transform: "translate(-226.395 -344.585)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M252.148,344.553a4.382,4.382,0,1,1-4.418,4.381A4.256,4.256,0,0,1,252.148,344.553Zm0,1.6a2.789,2.789,0,1,0,2.579,2.781A2.561,2.561,0,0,0,252.148,346.153Z",
    transform: "translate(-228.379 -344.553)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M261.393,344.724h1.828v5.03a1.956,1.956,0,1,0,3.912,0v-5.03h1.828v5.08c0,2.108-1.206,3.543-3.771,3.543-2.591,0-3.8-1.448-3.8-3.53Z",
    transform: "translate(-230.897 -344.585)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M273.979,353.195v-8.471h3.961a2.721,2.721,0,1,1,0,5.436h-2.157v3.035Zm3.72-6.921h-1.917v2.336H277.7a1.17,1.17,0,1,0,0-2.336Z",
    transform: "translate(-233.218 -344.585)",
    fill: "#1a1818"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7",
    transform: "translate(221.595 232.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M255.7,242.483l-4.439,4.439,2.217,2.216-1.11,1.11-1.109-1.11h0l-1.109-1.109-2.219,2.219-1.11-1.11,2.222-2.222v0h0l-3.328-3.327h0l-3.329,3.329h0l0,0,2.219,2.219-1.107,1.107-3.329-3.329,5.11-5.11h6.658l-2.89,2.889,1.11,1.11,4-4h0l1.569-1.569h0v0l-1,0H244.628l0,0-6.684,6.684,1.109,1.11,0,0,3.33,3.33,1.109,1.109,1.11-1.109h0l1.107-1.107,1.109,1.109-1.109,1.11h0l-1.11,1.109,2.219,2.219-1.109,1.109-2.223-2.222v0h0l-3.328,3.327,1.109,1.11,1.113,1.113h0l1.11,1.109,2.219-2.219,1.107,1.107-3.33,3.329-5.11-5.11v-6.658l2.89,2.889,1.109-1.109-4-4v0L236.809,248v0l0,0,0,1v10.1h0l0,0,6.684,6.684,1.109-1.109,0,0,4.439-4.439-2.217-2.216,1.11-1.11,1.109,1.11h0l1.109,1.109,2.219-2.219,1.11,1.11-2.222,2.222v0h0l3.328,3.328h0l2.222-2.223,1.107-1.107,0,0-2.219-2.219,1.107-1.107,3.329,3.329-5.11,5.11h-6.658l2.89-2.889-1.11-1.11-4,4h0l-1.569,1.569h0l0,0,1,0H255.67l0,0,6.684-6.684-1.109-1.11,0,0-3.33-3.33h0l-1.109-1.109-1.11,1.109h0l-1.107,1.107-1.109-1.109,1.109-1.109h0l1.11-1.11-2.219-2.219,1.109-1.109,2.223,2.222v0h0l3.328-3.327h0l-1.109-1.11-1.113-1.113-1.107-1.107,0,0-2.219,2.219-1.107-1.107,3.33-3.33,5.11,5.111v6.658l-2.89-2.89-1.109,1.109,4,4v0l1.569,1.569v-11.1h0l0,0-6.684-6.684-1.109,1.11Zm-11.1,4.436,1.113-1.113,1.11,1.11-1.113,1.113Zm-1.109,12.207-1.113-1.113,1.109-1.109,1.113,1.113Zm12.207,1.11-1.113,1.113-1.11-1.11,1.113-1.113Zm-5.549-9.987,1.11,1.109-1.11,1.11-1.109-1.11Zm-3.329,3.329,1.11-1.109,1.109,1.109-1.109,1.11Zm3.329,3.329L249.04,255.8l1.109-1.109,1.11,1.109Zm3.33-3.329-1.11,1.11-1.109-1.11,1.109-1.109Zm3.329-5.548,1.113,1.113-1.109,1.109-1.113-1.113Z",
    transform: "translate(-233.672 -237.099)",
    fill: "#b1904e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28",
    "data-name": "Caminho 28",
    d: "M256.266,236.39h-13.65l-9.653,9.653v13.651l9.653,9.653h13.65l9.653-9.653V246.043Zm8.083,22.654-8.733,8.733h-12.35l-8.733-8.733V246.693l8.733-8.733h12.35l8.733,8.733Z",
    transform: "translate(-232.963 -236.39)",
    fill: "#b1904e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupLogo);
export default __webpack_public_path__ + "static/media/group-logo.dcf8ca3c3ad195343ccac2169f3674bf.svg";
export { ForwardRef as ReactComponent };